import {
  UPDATE_PLC_SAFETY_EVENT,
  UPDATE_PLC_SAFETY_EVENT_SUCCESSFUL,
  UPDATE_PLC_SAFETY_EVENT_FAILED,
} from './actionTypes';

export const updatePlcSafetyEvent = (event) => ({
  type: UPDATE_PLC_SAFETY_EVENT,
  payload: { event },
});

export const updatePlcSafetyEventSuccessful = (message) => ({
  type: UPDATE_PLC_SAFETY_EVENT_SUCCESSFUL,
  payload: message,
});

export const updatePlcSafetyEventFailed = (message) => ({
  type: UPDATE_PLC_SAFETY_EVENT_FAILED,
  payload: message,
});
